@if (missingPaymentAlert && (rolId == 2 || rolId == 3) ) {
  <app-fixed-notification class="d-flex justify-content-center mx-3"></app-fixed-notification>
}

@if (size < minimalScreen || isMobile) {
  <app-inital-page-mobile>
  </app-inital-page-mobile>
}

@if (size > minimalScreen && !isMobile) {
  <app-inital-page-desktop>
  </app-inital-page-desktop>
}

